'use client';

import { useTranslation } from 'react-i18next';

import { Input } from '@kit/ui/input';
import { Label } from '@kit/ui/label';

import type { HeightImperialInputProps } from '../types';

/**
 * Dual input component for height in imperial units (feet and inches)
 */
export function HeightImperialInput({
  feetValue,
  inchesValue,
  onChange,
  label,
  min,
  max,
}: HeightImperialInputProps) {
  const { t } = useTranslation();
  const minFeet = min ? Math.floor(min / 30.48) : undefined;
  const maxFeet = max ? Math.ceil(max / 30.48) : undefined;

  return (
    <div className="flex gap-2">
      <div className="flex-1">
        <Input
          type="number"
          placeholder={t('dancer:heightImperial.feetPlaceholder')}
          value={feetValue}
          onChange={(e) => onChange(e.target.value, inchesValue)}
          min={minFeet}
          max={maxFeet}
          aria-label={t('dancer:heightImperial.feetLabel', { label })}
        />
        <Label className="text-muted-foreground mt-1 text-xs">ft</Label>
      </div>
      <div className="flex-1">
        <Input
          type="number"
          placeholder={t('dancer:heightImperial.inchesPlaceholder')}
          value={inchesValue}
          onChange={(e) => onChange(feetValue, e.target.value)}
          min={0}
          max={11}
          aria-label={t('dancer:heightImperial.inchesLabel', { label })}
        />
        <Label className="text-muted-foreground mt-1 text-xs">in</Label>
      </div>
    </div>
  );
}
